import { render, staticRenderFns } from "./PublicCatalogProductCard.vue?vue&type=template&id=0963b83a&scoped=true&"
import script from "./PublicCatalogProductCard.vue?vue&type=script&lang=js&"
export * from "./PublicCatalogProductCard.vue?vue&type=script&lang=js&"
import style0 from "./PublicCatalogProductCard.vue?vue&type=style&index=0&id=0963b83a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0963b83a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCard,VChip,VIcon,VImg})
